import { ProductName } from 'Constants/products.constants';
import { formatDateToDDMMYYYY } from 'Utils/date/date.utils';
import { isDefined } from 'Utils/type.utils';
import { mapCancelDateCategory } from '../cancelTravelForm.helpers';
import {
  CancelTravelFormValues,
  CancelTravelRequest,
} from '../cancelTravelForm.types';

export function mapToCancellationTravel(
  values: CancelTravelFormValues,
): CancelTravelRequest {
  return {
    insuranceName: ProductName.TRAVEL,
    cancelDateCategory: mapCancelDateCategory(values),
    futureCancelDate: isDefined(values.futureCancelDate)
      ? formatDateToDDMMYYYY(values.futureCancelDate)
      : undefined,
  };
}
